import angular from 'angular';

const directiveModule = angular.module('tinaba.directives.isNumber', [])
    .directive('isNumber', () => {
      return {
        require: '?ngModel',
        scope: {
          max: "="
        },
        link: {
          pre: (scope, element, attrs, ngModelCtrl) => {
            if (!ngModelCtrl) {
              return;
            }

            ngModelCtrl.$parsers.push((val) => {
              if (angular.isUndefined(val)) {
                val = ''; // eslint-disable-line
              }

              const telType = attrs.type === 'tel';

              let clean = telType ? val.replace(/[^0-9\+]/g, '') : val.replace(/[^0-9]/g, '');


              // GESTIONE del CARATTERE PLUS "+" (Mattia A.)
              if (telType && clean.indexOf('+') !== -1) {
                const plusCheck = clean.split('+');
                clean = `+${plusCheck[0]}${plusCheck[1]}`;
                if (!angular.isUndefined(plusCheck[2])) {
                  clean = clean + plusCheck[2];
                }
              }

              if (scope.max !== undefined && clean > scope.max) clean = scope.max.toString();

              if (val !== clean) {
                ngModelCtrl.$setViewValue(clean);
                ngModelCtrl.$render();
              }
              return clean;
            });

            element.bind('keypress', (event) => {
              if (event.keyCode === 32) {
                event.preventDefault();
              }
            });
          }
        }
      };
    });

export default directiveModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/directives/isNumber.js
 **/